import React, { useState } from 'react';
import { ReactComponent as Logo } from '../logo/logo.svg';
import Link from '../components/Link/Link';
import { Button } from '../components/Button/Button';
import Close from '../icons/Close';
import Menu from '../icons/Menu';
import { getRouteByName } from '../../../router/routes';
import { Link as RouterLink } from 'react-router-dom';

interface Props {
  selected: string;
  handleMenuClick: (sectionDest: string) => void;
}

const Header: React.FC<Props> = ({ handleMenuClick, selected }) => {
  const [menuIsOpen, setMenuIsOpen] = useState<boolean>(false);

  return (
    <header>
      <div className="header-content-wrapper flex justify-between items-center">
        <div className="logo" onClick={() => handleMenuClick('intro')}>
          <Logo />
        </div>

        <nav className={`menu-nav w-full ${menuIsOpen ? '' : 'mob-hidden'}`}>
          <ul className="flex flex-col items-center landing_nav navbar-nav">
            <li>
              <Link
                title="Features"
                onClickHandler={() => handleMenuClick('features')}
                selected={selected === 'features'}
              />
            </li>
            <li>
              <Link title="Roles" onClickHandler={() => handleMenuClick('roles')} selected={selected === 'roles'} />
            </li>
            {/* <li>
              <Link
                title="Donate"
                onClickHandler={() => handleMenuClick('donation')}
                selected={selected === 'donation'}
              />
            </li> */}
            <li>
              <Link
                title="About us"
                onClickHandler={() => handleMenuClick('about-us')}
                selected={selected === 'about-us'}
              />
            </li>
            <li>
              <Link
                title="Support"
                onClickHandler={() => handleMenuClick('contact')}
                selected={selected === 'contact'}
              />
            </li>
            {/* TEMPORARILY HIDDEN <li>
                <Link
                  title="Toolkit"
                  onClickHandler={() => handleMenuClick('toolkit')}
                  selected={selected === 'toolkit'}
                  data-to-scrollspy-id="toolkit"
                />
              </li>*/}

            <hr className="mobileCtrlMenuHr" />

            <li className="mobileCtrlMenuLogin">
              <RouterLink className="landing_link" to={getRouteByName('RouteLogin').path}>
                Login
              </RouterLink>
            </li>
            <li className="mobileCtrlMenuSignUp">
              <RouterLink className="landing_link" to={getRouteByName('RouteSignUp').path}>
                Sign up
              </RouterLink>
            </li>
          </ul>
        </nav>
        <div className="header-button-container  ">
          <div className="flex items-center justify-end  w-full">
            <RouterLink to={getRouteByName('RouteLogin').path}>
              <Button
                variant="solid"
                className="login-button"
                style={{ marginRight: '4px', borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }}
              >
                Login
              </Button>
            </RouterLink>
            <RouterLink to={getRouteByName('RouteSignUp').path}>
              <Button
                variant="solid"
                className="login-button"
                style={{ marginRight: '4px', borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px' }}
              >
                Sign up
              </Button>
            </RouterLink>
          </div>
        </div>

        <div className="header-nav-content flex relative">
          {/* TEMPORARILY HIDDEN <div
              className={`lang-button flex items-center cursor-pointer ${menuIsOpen ? 'invisible' : ''}`}
              onClick={() => {
                setLangMenuIsOpen(!langMenuIsOpen);
              }}
            >
              <Globe /> <span className="ml-1.5">EN</span>
            </div>*/}

          {/*langMenuIsOpen && (
              <nav className="lang-nav absolute rounded-lg">
                <ul>
                  <li className="selected">English</li>
                  <li>Chinese</li>
                </ul>
              </nav>
            )*/}

          <div
            className="menu-button flex items-center ml-4 cursor-pointer"
            onClick={() => {
              //setLangMenuIsOpen(false); // TEMPORARILY INACTIVE
              setMenuIsOpen(!menuIsOpen);
            }}
          >
            {menuIsOpen ? <Close /> : <Menu />} <span className="ml-2">{menuIsOpen ? 'Close' : 'Menu'}</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
